/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import AqaNewPlan from '../model/AqaNewPlan';
import AqaSubscriptionDetails from '../model/AqaSubscriptionDetails';
import AqaSubscriptionUpdateResponse from '../model/AqaSubscriptionUpdateResponse';
import PriceRequest from '../model/PriceRequest';

/**
* AQASalesController service.
* @module api/AQASalesControllerApi
* @version v0
*/
export default class AQASalesControllerApi {

    /**
    * Constructs a new AQASalesControllerApi. 
    * @alias module:api/AQASalesControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getAllPlans operation.
     * @callback moduleapi/AQASalesControllerApi~getAllPlansCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaNewPlan>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves all plans
     * @param {module:api/AQASalesControllerApi~getAllPlansCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllPlans(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [AqaNewPlan];

      return this.apiClient.callApi(
        '/api/v1/sales/plans', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getPlan operation.
     * @callback moduleapi/AQASalesControllerApi~getPlanCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaNewPlan{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves one plan from its id
     * @param {String} planId 
     * @param {module:api/AQASalesControllerApi~getPlanCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getPlan(planId, callback) {
      
      let postBody = null;
      // verify the required parameter 'planId' is set
      if (planId === undefined || planId === null) {
        throw new Error("Missing the required parameter 'planId' when calling getPlan");
      }

      let pathParams = {
        'planId': planId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AqaNewPlan;

      return this.apiClient.callApi(
        '/api/v1/sales/plans/{planId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSubscriptionDetails operation.
     * @callback moduleapi/AQASalesControllerApi~getSubscriptionDetailsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaSubscriptionDetails{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets some details of a subscription. Use to decide whether a user already has a subscription
     * @param {module:api/AQASalesControllerApi~getSubscriptionDetailsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSubscriptionDetails(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaSubscriptionDetails;

      return this.apiClient.callApi(
        '/api/v1/sales/account/subscriptionDetails', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the price operation.
     * @callback moduleapi/AQASalesControllerApi~priceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaNewPlan{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Prices an order based on the number of users and sources, now returns an AqaNewPlan so it will show Monthly and Yearly prices
     * @param {Object} opts Optional parameters
     * @param {Number} opts.numberOfEditors  (default to <.>)
     * @param {Number} opts.numberOfSources  (default to <.>)
     * @param {String} opts.currency  (default to <.>)
     * @param {String} opts.planId 
     * @param {String} opts.paymentFrequency 
     * @param {module:api/AQASalesControllerApi~priceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    price(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        'numberOfEditors': opts['numberOfEditors'],'numberOfSources': opts['numberOfSources'],'currency': opts['currency'],'planId': opts['planId'],'paymentFrequency': opts['paymentFrequency']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaNewPlan;

      return this.apiClient.callApi(
        '/api/v1/sales/products/price', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateSubscription operation.
     * @callback moduleapi/AQASalesControllerApi~updateSubscriptionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaSubscriptionUpdateResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates a subscription
     * @param {module:model/PriceRequest} body 
     * @param {module:api/AQASalesControllerApi~updateSubscriptionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateSubscription(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateSubscription");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AqaSubscriptionUpdateResponse;

      return this.apiClient.callApi(
        '/api/v1/sales/subscriptions', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}